import { createApp } from 'vue';
import App from './App.vue';
import router from "./router";
import AOS from 'aos';
import 'aos/dist/aos.css';
import i18n from './i18n';
import store from "./state/store";

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import BootstrapVueNext from 'bootstrap-vue-next';
import vClickOutside from "click-outside-vue3";
import VueApexCharts from "vue3-apexcharts";
import { vMaska } from "maska"

import VueFeather from 'vue-feather';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

import filterPersistence from './mixins/filterPersistence';
import prefillFromChatbot from './mixins/prefillFromChatbot';
import keepAliveRefresh from './mixins/keepAliveRefresh';
import CalcInput from '@/components/CalcInput.vue';
import ExportPrintMenu from '@/components/ExportPrintMenu.vue';
import TableCellSelector from '@/plugins/tableCellSelector';

// Unified print system — shared components used across all print routes.
// Registered globally so print views can use them without per-file imports.
import PrintLayout from '@/components/print/PrintLayout.vue';
import PrintHeader from '@/components/print/PrintHeader.vue';
import PrintFooter from '@/components/print/PrintFooter.vue';
import PrintTitle from '@/components/print/PrintTitle.vue';
import PrintMetaGrid from '@/components/print/PrintMetaGrid.vue';
import PrintPartyBlock from '@/components/print/PrintPartyBlock.vue';
import PrintTable from '@/components/print/PrintTable.vue';
import PrintTotalsBox from '@/components/print/PrintTotalsBox.vue';
import PrintAmountInWords from '@/components/print/PrintAmountInWords.vue';
import PrintBankDetailsBlock from '@/components/print/PrintBankDetailsBlock.vue';
import PrintTermsBlock from '@/components/print/PrintTermsBlock.vue';
import PrintSignatoryBlock from '@/components/print/PrintSignatoryBlock.vue';
import PrintWatermark from '@/components/print/PrintWatermark.vue';
import PrintActionBar from '@/components/print/PrintActionBar.vue';
import StoreDocumentPrint from '@/components/print/StoreDocumentPrint.vue';
import ReportPrint from '@/components/print/ReportPrint.vue';

import '@/assets/scss/config/default/app.scss';
import "leaflet/dist/leaflet.css";
import '@/assets/scss/mermaid.min.css';
import 'bootstrap/dist/js/bootstrap.bundle'

// FakeBackend authentication (disabled — using IntegralAPI backend)
// import { configureFakeBackend } from './helpers/fake-backend';
// configureFakeBackend();


// Firebase authentication
// import { initFirebaseBackend } from './authUtils';

// const firebaseConfig = {
//     apiKey: process.env.VUE_APP_APIKEY,
//     authDomain: process.env.VUE_APP_AUTHDOMAIN,
//     databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
//     projectId: process.env.VUE_APP_PROJECTId,
//     storageBucket: process.env.VUE_APP_STORAGEBUCKET,
//     messagingSenderId: process.env.VUE_APP_MEASUREMENTID
// };

// initFirebaseBackend(firebaseConfig);



AOS.init({
    easing: 'ease-out-back',
    duration: 1000
});

const app = createApp(App);

// Swallow ApexCharts mount/unmount race noise without losing other errors.
// "Element not found" fires when the chart inits before its container has been
// laid out; "Paper is undefined" fires when destroy is called before init
// finished. Both are harmless — Vue re-renders cleanly on the next pass.
app.config.errorHandler = (err, _instance, info) => {
    const msg = String(err?.message || err || "");
    if (
        msg.includes("Paper is undefined") ||
        msg.includes("Element not found") ||
        msg.includes("globals.dom.Paper")
    ) {
        return;
    }
    // eslint-disable-next-line no-console
    console.error("[vue]", info, err);
};

app
    .mixin(filterPersistence)
    .mixin(prefillFromChatbot)
    .mixin(keepAliveRefresh)
    .use(store)
    .use(router)
    .use(TableCellSelector, { router })
    .use(VueApexCharts)
    .use(BootstrapVueNext)
    .component(VueFeather.type, VueFeather)
    .component('flat-pickr', flatPickr)
    .component('CalcInput', CalcInput)
    .component('ExportPrintMenu', ExportPrintMenu)
    .component('PrintLayout', PrintLayout)
    .component('PrintHeader', PrintHeader)
    .component('PrintFooter', PrintFooter)
    .component('PrintTitle', PrintTitle)
    .component('PrintMetaGrid', PrintMetaGrid)
    .component('PrintPartyBlock', PrintPartyBlock)
    .component('PrintTable', PrintTable)
    .component('PrintTotalsBox', PrintTotalsBox)
    .component('PrintAmountInWords', PrintAmountInWords)
    .component('PrintBankDetailsBlock', PrintBankDetailsBlock)
    .component('PrintTermsBlock', PrintTermsBlock)
    .component('PrintSignatoryBlock', PrintSignatoryBlock)
    .component('PrintWatermark', PrintWatermark)
    .component('PrintActionBar', PrintActionBar)
    .component('StoreDocumentPrint', StoreDocumentPrint)
    .component('ReportPrint', ReportPrint)
    .directive("maska", vMaska)
    .use(i18n)
    .use(VueSweetalert2)
    .use(vClickOutside).mount('#app');